/**
 * Manipulador para blocos `listing`.
 * Recebe (block, content) e retorna o bloco possivelmente modificado.
 */
export const listingHandler = (block, content) => {
  if (!block) return block;

  const query = block.querystring?.query;

  // Se existe querystring com caminho relativo, substitui pelo caminho absoluto
  if (query) {
    const newQuery = query.map((criteria) => {
      const isRelativePathCriteria =
        criteria.i === 'path' &&
        criteria.o === 'plone.app.querystring.operation.string.relativePath' &&
        content?.['@id'] &&
        (criteria.v === './' || criteria.v === '../');

      if (!isRelativePathCriteria) return criteria;

      const baseUrl = new URL(content['@id']);
      let targetPath = baseUrl.pathname;

      if (criteria.v === '../') {
        targetPath = `${targetPath}/../`;
        return {
          ...criteria,
          v: targetPath,
        };
      }

      return {
        ...criteria,
        o: 'plone.app.querystring.operation.string.absolutePath',
        v: `${targetPath}::1`,
      };
    });

    // Detecta se houve mudança comparando referências
    const hasChanged = newQuery.some((item, i) => item !== query[i]);

    if (hasChanged) {
      return {
        ...block,
        querystring: {
          ...block.querystring,
          query: newQuery,
        },
      };
    }
  }

  // Caso não exista querystring definida, usa o comportamento original
  if (!block.querystring) {
    const uid = content?.UID;
    if (!uid) return block;

    return {
      ...block,
      querystring: {
        query: [
          {
            i: 'path',
            o: 'plone.app.querystring.operation.string.absolutePath',
            v: `${uid}::1`,
          },
        ],
        sort_order: 'ascending',
      },
    };
  }
  return block;
};

export default listingHandler;
